<template>
  <div class="areastatic">
    <div class="contentbox">
      <ul class="topBox">
        <li>
          <span class="td1">申请时间</span>
          <span class="td2">提现金额</span>
          <span class="td3">订单状态</span>
        </li>
      </ul>
      <van-divider dashed v-if="list.length ===0">暂无数据</van-divider>
      <div class="tableCont" v-else>
        <van-pull-refresh class="scrolldiv" v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :offset="80" :immediate-check="false" :finished="finished" finished-text="我是有底线的" @load="onLoad">
            <ul>
              <li v-for="(item,i) in list" :key="'list'+i">
                <span class="td1">
                  <i class="time">
                    {{item.applyDate.split(' ')[0]}} <br><em>{{item.applyDate.split(' ')[1]}}</em>
                  </i>
                </span>
                <span class="td2">{{item.amount.toFixed(2)}}</span>
                <span class="td3" :class="'state'+item.state">{{item.state|fstate}}</span>
              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      PageNumber: 1,
      PageSize: 20,
      total: 0
    };
  },
  filters: {
    fstate: function(data) {
      let sta = '';
      switch (data) {
        case 1:
          sta = '成功';
          break;
        case 2:
          sta = '付款中';
          break;
        case 3:
          sta = '审核中';
          break;
        case 4:
          sta = '待付款';
          break;
        case 5:
          sta = '审核失败';
          break;
        case 6:
          sta = '拒绝付款';
          break;
      }
      return sta;
    }
  },
  methods: {
    getlist() {
      this.$api.home
        .moneyRecord({
          StartApplyDate: '',
          EndApplyDate: '',
          StartAmount: '',
          EndAmount: '',
          State: '0',
          uuid: this.$route.query.uuid,
          PageNumber: this.PageNumber,
          PageSize: this.PageSize
        })
        .then((data) => {
          if (data.status === 200) {
            if (this.PageNumber === 1) {
              this.list = data.data;
            } else {
              this.list = this.list.concat(data.data);
            }
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
            if (this.list.length >= this.total) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
              this.PageNumber++;
            }
            this.refreshing = false;
          } else {
            this.list = [];
            this.refreshing = false;
            this.finished = false;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 下拉刷新
    onRefresh() {
      this.PageNumber = 1;
      this.finished = false;
      this.getlist();
    },
    // 上拉加载
    onLoad() {
      if (this.finished) {
        return;
      }
      this.getlist();
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.areastatic {
  height: 100%;
  // background: url(../assets/images/bg.jpg) no-repeat center top;
  background-size: 100% auto;
  padding-top: 40px;
  padding-bottom: 30px;
  .contentbox {
    position: relative;
    padding-top: 38px;
    margin: 0 20px;
    height: 100%;
    background: #fff;
    text-align: center;
    border: 1px solid #c6c6c6;
    // border-bottom: none;
    .topBox {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      li {
        display: flex;
        flex-flow: row nowrap;
        span {
          padding: 0 5px;
          height: 38px;
          line-height: 38px;
          font-size: 15px;
          color: #646464;
          font-weight: bold;
          border-right: 1px solid #c6c6c6;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          word-break: break-all;
          border-bottom: 1px solid #c6c6c6;
          &.td1 {
            width: 40%;
          }
          &.td2 {
            width: 30%;
          }
          &.td3 {
            width: 30%;
            border-right: none;
          }
        }
      }
    }
    .tableCont {
      height: 100%;
      .scrolldiv {
        height: 100%;
        overflow-y: auto;
      }
      ul {
        li {
          display: flex;
          flex-flow: row nowrap;
          &:nth-child(ODD) {
            background: #dce8fe;
          }
          span {
            padding: 0 5px;
            height: 38px;
            line-height: 38px;
            font-size: 14px;
            color: #262626;
            // font-weight: bold;
            border-right: 1px solid #c6c6c6;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: break-all;
            border-bottom: 1px solid #c6c6c6;
            .time {
              display: block;
              padding-top: 5px;
              line-height: 15px;
              em {
                color: #5b5b5b;
              }
            }
            &.state1 {
              color: #01ba01;
            }
            &.state2 {
              color: #ffa200;
            }
            &.state3 {
              color: #ffa200;
            }
            &.state4 {
              color: #737373;
            }
            &.state5 {
              color: #fe0000;
            }
            &.state6 {
              color: #fe0000;
            }
            &.td1 {
              width: 40%;
            }
            &.td2 {
              width: 30%;
            }
            &.td3 {
              width: 30%;
              border-right: none;
            }
          }
        }
      }
    }
  }
}
</style>
